import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidatorsService } from '../../services/validators.service';

export interface INumPadOptions {
  title: string;
  inputText?: string;
  buttonText?: string;
}

@Component({
    selector: 'app-num-pad',
    templateUrl: './num-pad.component.html',
    styleUrls: ['./num-pad.component.scss'],
    standalone: false
})
export class NumPadComponent implements OnInit {
  @Input() options: INumPadOptions = {
    title: ''
  };

  form: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();

  patternReference: any = {};

  constructor(private modalCtrl: ModalController, private fb: FormBuilder, public validators: ValidatorsService)
  {

  }

  ngOnInit() {
    /*
    this.form = this.fb.group({
      value: ['', this.validators.formBuilderValidationInitializer(true, 6)]
    });
    */
    this.form = this.fb.group({
      value: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, 6),
        updateOn: 'change'
      })
    });

    /*
    this.form["patternReference"] = {
      value: 6
    };
    */
    this.patternReference = {
      value: 6
    };
    

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);
  }

  cancel() {
    this.modalCtrl.dismiss(null);
  }

  ok() {
    //sanitizing
    this.form.setValue(this.validators.multiSanitizerInput(this.form.value));

    if (!this.form.valid)
      return;

    let result = this.form.get('value').value;
    this.modalCtrl.dismiss(result);
  }
}
